module.exports = __webpack_public_path__ + "pic4.jpg?747d0445b397adab8721cbafa758f08e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/featured/pic4.jpg
// module id = 97
// module chunks = 13